"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var stimulus_1 = require("stimulus");
var REF_CODE_CHANNEL_NAME = 'ref_code_sync';
var REF_CODE_KEY = 'ref_code';
var REQUEST_TYPE = 'request_ref_code';
var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.channel = null;
        return _this;
    }
    default_1.prototype.connect = function () {
        this.setupBroadcastChannel();
        this.storeRefCodeInSessionStorage();
        this.setTrackingInfo();
        this.requestRefCodeFromOtherTabs();
    };
    default_1.prototype.disconnect = function () {
        if (this.channel) {
            this.channel.close();
            this.channel = null;
        }
    };
    default_1.prototype.setupBroadcastChannel = function () {
        var _this = this;
        if (typeof BroadcastChannel === 'undefined') {
            return;
        }
        this.channel = new BroadcastChannel(REF_CODE_CHANNEL_NAME);
        this.channel.onmessage = function (event) {
            var _a;
            var _b = (event.data || {}), type = _b.type, ref_code = _b.ref_code;
            if (type === REF_CODE_KEY &&
                typeof ref_code === 'string' &&
                ref_code.length > 0 &&
                !sessionStorage.getItem(REF_CODE_KEY)) {
                sessionStorage.setItem(REF_CODE_KEY, ref_code);
                _this.setTrackingInfo();
            }
            if (type === REQUEST_TYPE) {
                var refCode = sessionStorage.getItem(REF_CODE_KEY);
                refCode && ((_a = _this.channel) === null || _a === void 0 ? void 0 : _a.postMessage({ type: REF_CODE_KEY, ref_code: refCode }));
            }
        };
    };
    default_1.prototype.storeRefCodeInSessionStorage = function () {
        var queryString = window.location.search;
        var params = new URLSearchParams(queryString);
        var refCode = params.get(REF_CODE_KEY);
        var oldRefCode = sessionStorage.getItem(REF_CODE_KEY);
        if (typeof refCode === 'string' &&
            refCode.length > 0 &&
            oldRefCode === null) {
            sessionStorage.setItem(REF_CODE_KEY, refCode);
            this.broadcastRefCode(refCode);
        }
    };
    default_1.prototype.requestRefCodeFromOtherTabs = function () {
        if (this.channel && sessionStorage.getItem(REF_CODE_KEY) === null) {
            this.channel.postMessage({ type: REQUEST_TYPE });
        }
    };
    default_1.prototype.broadcastRefCode = function (refCode) {
        var _a;
        (_a = this.channel) === null || _a === void 0 ? void 0 : _a.postMessage({ type: REF_CODE_KEY, ref_code: refCode });
    };
    default_1.prototype.setTrackingInfo = function () {
        var cookieData = {
            ref_code: sessionStorage.getItem(REF_CODE_KEY),
            time: new Date().toISOString()
        };
        document.cookie = "tracking_info=".concat(encodeURIComponent(JSON.stringify(cookieData)), "; path=/;");
    };
    return default_1;
}(stimulus_1.Controller));
exports.default = default_1;
